import image from '../../../../../public/img/first-view-image9-pc.webp';
import { FontSize } from '../../../../constants/FontSize';
import { PageUrl } from '../../../../constants/PageUrl';
import { SectionId } from '../../../../constants/SectionId';
import Color from '../../../../styles/Color';
import SectionTitle from '../../atoms/SectionTitle';
import { SectionWrapper } from '../../templates/SectionWrapper';
import { CircleImageWithLink } from './CircleImageWithLink';
import styles from './programs.module.scss';

export const Programs = () => (
  <SectionWrapper id={SectionId.DAYCARE_ENVIRONMENTS} backgroundColor={Color.brandOgange100}>
    <SectionTitle fontSize={FontSize.MEDIUM} variant="border">
      英語も、リトミックも
      <br />
      園生活が、そのまま習い事相当に
      <br />
      多彩な教育プログラム
    </SectionTitle>
    <div className={styles['content-wrapper']}>
      <p className={styles['body-text']}>
        当園では、子どもたちの「やりたい！」という気持ちを刺激し、それを「できた！」へとつなげる教育を提供しています。
        <br />
        <br />
        1〜5歳を対象に、少人数制のなかでモンテッソーリ教育に英語・リトミック・クッキング・体育・華道を組み合わせた「教育6本柱」を実践しています。これら多彩なプログラムを通じて、子どもたちは興味や好奇心を深め、楽しみながら学ぶことができます。
        <br />
        <br />
        英語・体育は週1回、リトミックは2週間に1回、クッキング・華道は月1回で、すべて基本月額に含まれます。参加は年齢で分けず、やってみたい子が自分で選びます。
        <br />
        <br />
        日々の保育の中に、英語やリトミックといった習い事がすでに組み込まれているから、あらためて外に習い事を探しに行く必要がありません。
        <br />
        <br />
        「学び」は単なる知識の習得ではなく、子どもが自らの可能性を広げる力。その力を伸ばし、未来へとつなげていく。それが、当園が目指す教育のかたちです。
      </p>
      <CircleImageWithLink
        label="教育内容を詳しく見る →"
        href={PageUrl.DAYCARE_PROGRAMS}
        imageSrc={image}
        color={Color.brandOgange200}
      />
    </div>
  </SectionWrapper>
);
